export const BASE_PATH = "v1/geotax/";